// extracted by mini-css-extract-plugin
export default {"container":"GYMu13rCuoLH1wJ91zz2","typography":"TO6hKm8NgJNtGkbUGAsF"};